import { AnyAction } from 'redux'

const moduleName = 'MMB/modal'

export enum ModalActionType {
  SHOW_MODAL = 'SHOW_MODAL',
  HIDE_MODAL = 'HIDE_MODAL',
}

const initialState = {
  visible: false,
  closable: true,
  scrolling: false,
  maxWidth: null,
  minWidth: null,
  scrollinghorizontal: false,
  component: null,
}

export default function reducer(
  state: ModalState = initialState,
  action: AnyAction,
): ModalState {
  switch (action.type) {
    case `${moduleName}/${ModalActionType.SHOW_MODAL}`:
      return {
        ...state,
        visible: true,
        closable: action.closable,
        scrolling: action.scrolling,
        maxWidth: action.maxWidth,
        minWidth: action.minWidth,
        scrollinghorizontal: action.scrollinghorizontal,
        component: action.component,
      }
    case `${moduleName}/${ModalActionType.HIDE_MODAL}`:
      return {
        ...state,
        visible: false,
        component: null,
      }
    default:
      return state
  }
}

export function showModalAction(
  component: React.ReactNode,
  options: ModalOptionsType = {},
) {
  const optionsWithDefaults = {
    closable: true,
      scrolling: false,
      maxWidth: null,
      minWidth: null,
      scrollinghorizontal: false,
    ...options,
  }
  return {
    type: `${moduleName}/${ModalActionType.SHOW_MODAL}`,
    component,
    ...optionsWithDefaults,
  }
}

export function hideModalAction() {
  return {
    type: `${moduleName}/${ModalActionType.HIDE_MODAL}`,
    component: null,
  }
}

export type ModalState = {
  visible: boolean
  closable: boolean
  scrolling?: boolean
  scrollinghorizontal?: boolean
  maxWidth?: number
  minWidth?: number
  component: React.ReactNode
}

export type ModalOptionsType = {
  closable?: boolean
}
